<template>
  <div class="child-safety-policy">
    <h1>Child Safety Policy</h1>

    <p>
      At <strong>Restroworld</strong>, we are deeply committed to creating a safe, respectful, and inclusive platform for all users. While our platform is focused on food lovers and food-related social media content, we maintain strict policies to ensure no inappropriate, harmful, or abusive content is shared or tolerated.
    </p>

    <h2>1. No Child-Targeted Content</h2>
    <p>
      Restroworld is designed for individuals above the age of 18. We do not promote, feature, or encourage content that targets children in any form. The platform is intended solely for food-related content, restaurant reviews, community food sharing, and related services.
    </p>

    <h2>2. Zero Tolerance Toward CSAE</h2>
    <p>
      We strictly prohibit the sharing or promotion of any content related to child sexual abuse and exploitation (CSAE). Any such content, if detected, will be immediately reported to appropriate legal authorities and removed from our platform without notice.
    </p>

    <h2>3. Content Monitoring & Reporting</h2>
    <p>
      We actively monitor user-generated content using both automated systems and manual moderation to prevent any form of harmful or policy-violating media. Users can report suspicious or harmful behavior via our contact form or by emailing us directly.
    </p>

    <h2>4. Compliance & Cooperation</h2>
    <p>
      Restroworld fully complies with Google Play's
      <a href="https://support.google.com/googleplay/android-developer/answer/9876935" target="_blank" rel="noopener">Child Safety Standards</a>
      and local laws related to child protection and digital safety.
    </p>

    <h2>5. Designated Contact</h2>
    <p>
      For any concerns or reports regarding child safety or CSAE content, you may contact our safety officer directly at: <br />
      <strong>Email:</strong> contact.infinitybrains@gmail.com
    </p>

    <h2>6. Final Note</h2>
    <p>
      Restroworld stands firmly against any form of exploitation and is committed to keeping our platform secure and trustworthy for the food community. We encourage all users to report any violations or concerns immediately.
    </p>
  </div>
</template>

<script>
export default {
  name: "ChildSafetyPolicy",
};
</script>

<style scoped>
.child-safety-policy {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  font-family: Arial, sans-serif;
  color: #333;
}

h1 {
  font-size: 32px;
  color: #c0392b;
  margin-bottom: 1.5rem;
}

h2 {
  font-size: 22px;
  margin-top: 1.8rem;
  color: #2c3e50;
}

p {
  font-size: 16px;
  margin-bottom: 1.2rem;
  line-height: 1.6;
}

a {
  color: #3498db;
  text-decoration: underline;
}
</style>
